import { Box } from '@wix/design-system'
import React, { FC, ReactNode } from 'react'

import { Heading } from '../../reusable/Heading/Heading'
import { dataHooks } from './WixIntrosBoxXL.dataHooks'

type TitleProps = {
  children?: ReactNode
}

export const Title: FC<TitleProps> = ({ children }) => {
  return (
    <Box marginBottom="SP7">
      <Heading size="xxxl" dataHook={dataHooks.title()}>
        {children}
      </Heading>
    </Box>
  )
}
